import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Glyphicon, Nav, Navbar, NavDropdown, MenuItem } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import LDClient from 'launchdarkly-js-client-sdk';
import { Auth } from 'aws-amplify';
import Routes from './Routes';
import packageSetting from '../package.json';
import { invokeApig, signWSUrl } from './libs/awsLib';
import 'react-toastify/dist/ReactToastify.css';
import PageViewContainer from './containers/PageViewContainer';

/*
When implementing Live location tracking then uncomment this
const handleError = function(error){
  switch(error.code) {
    case error.PERMISSION_DENIED:
      return 'ERROR_PERMISSION_DENIED'
    case error.POSITION_UNAVAILABLE:
      return 'ERROR_POSITION_UNAVAILABLE'
    case error.TIMEOUT:
      return 'ERROR_TIMEOUT'
    case error.UNKNOWN_ERROR:
      return 'ERROR_UNKNOWN'
    default:
      return 'ERROR_UNKNOWN'
  }
}
*/

class App extends Component {
  constructor(props) {
    super(props);
    this.updateHighlight = this.updateHighlight.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.saveLocation = this.saveLocation.bind(this);
    this.constructorWebSocket = this.constructorWebSocket.bind(this);
    const highlight = window.location.pathname.split('/')[1].toLowerCase();

    this.state = {
      user: '',
      currentKey: highlight,
      views: {},
      authState: this.props.authState,
      position: { latitude: null, longitude: null, status: 'UNKNOWN' },
      staleVersion: false,
      hasAccessToDropOverride: false,
      hasAccessToJitManagement: false,
    };
  }

  async componentDidMount() {
    /*
    // When implementing Web Sockets uncomment code below
    this.setState({'ws':await this.constructorWebSocket()})
    window.onbeforeunload = function(event) {
        this.state.ws.close();
        return true
    }.bind(this);
    */
    this.intervalId = setInterval(this.determineVersion.bind(this), 300000); // timer is for 5 minutes
  }

  static getDerivedStateFromProps(props, state) {
    if (props.authState !== state.authState) {
      return {
        authState: props.authState,
      };
    }
    return null;
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.authState !== this.props.authState) {
      // check user access flags in LaunchDarkly
      try {
        const currentSession = await Auth.currentAuthenticatedUser();
        this.setState({
          user: currentSession.signInUserSession.idToken.payload.email,
        });
        localStorage.setItem(
          'userEmail',
          currentSession.signInUserSession.idToken.payload.email,
        );

        const LDCUser = {
          key: currentSession.signInUserSession.idToken.payload.email,
        };

        const ldclient = LDClient.initialize(
          process.env.REACT_APP_LAUNCH_DARKLY_CMS
            ? process.env.REACT_APP_LAUNCH_DARKLY_CMS
            : 'nlfaepofjeowiajfpoijewr',
          LDCUser,
        );

        ldclient.on('ready', () => {
          const allFlagsValue = ldclient.allFlags();

          this.setState({
            hasAccessToDropOverride: allFlagsValue['drop-override'],
            hasAccessToJitManagement: allFlagsValue['jit-management'],
          });
        });
      } catch (e) {
        if (localStorage.getItem('userEmail')) {
          localStorage.removeItem('userEmail');
        }

        const errorString = JSON.stringify(e);
        console.error(errorString);
      }

      try {
        const views = await this.views();
        this.setState({ views: views.body });
      } catch (e) {
        const errorString = JSON.stringify(e);
        console.error(errorString);
      }
    }
  }

  async componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  // TODO: refactor function to prevent `vars-on-top` and `no-vars` ESlint errors
  /* eslint-disable */
  determineVersion() {
    fetch(window.location.href, { cache: 'no-store' })
      .then((response) => response.text())
      .then((response) => {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(response, 'text/html');
        const oldScripts = htmlDoc.getElementsByTagName('script');
        const newScripts = document.getElementsByTagName('script');
        let oldScriptToCompare = '';
        let newScriptToCompare = '';
        for (var i = 0; i < oldScripts.length; i++) {
          if (oldScripts[i].src && oldScripts[i].src.includes('main')) {
            oldScriptToCompare = oldScripts[i].src;
          }
        }
        for (var i = 0; i < newScripts.length; i++) {
          if (newScripts[i].src && newScripts[i].src.includes('main')) {
            newScriptToCompare = newScripts[i].src;
          }
        }
        if (
          oldScriptToCompare !== newScriptToCompare &&
          this.state.staleVersion === false
        ) {
          this.setState({ staleVersion: true });
        }
      })
      .catch((err) => console.log(err));
  }
  /* eslint-disable */

  handleLogout() {
    Auth.signOut()
      .then(() => {
        this.props.onStateChange('signedOut', null);
      })
      .catch((err) => {
        console.error('err: ', err);
      });
  }

  views() {
    return invokeApig({
      path: '/views',
      method: 'GET',
    });
  }

  // TODO: Figuring out if can we remove this function, because `isAuthenticated` unused
  userHasAuthenticated = (authenticated) => {
    // eslint-disable-next-line react/no-unused-state
    this.setState({ isAuthenticated: authenticated });
  };

  async saveLocation(position) {
    console.log(position);
    const coords = {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
      timestamp: position.timestamp,
    };
    console.log(coords);
    await invokeApig({
      path: '/coords',
      method: 'PUT',
      body: coords,
    });
    coords.status = 'OK';
    this.setState({
      position: coords,
    });
  }

  updateHighlight(key) {
    this.setState({ currentKey: key });
  }

  displayToast() {
    toast.info(
      'You are on an old version of the software. Please refresh the page.',
      { autoClose: false },
    );
  }

  async constructorWebSocket() {
    const newSignedUrl = await signWSUrl(
      '22rqzcagtc.execute-api.us-west-2.amazonaws.com',
    );
    const ws = new WebSocket(newSignedUrl);
    ws.onclose = function (event) {
      console.error('WebSocket closed:', event);
    };
    ws.onerror = function (event) {
      console.error('WebSocket error observed:', event);
    };
    ws.onopen = function () {
      console.log('WebSocket is open now.');
    };
    ws.onmessage = function (event) {
      console.debug('WebSocket message received:', event);
    };
    return ws;
  }

  render() {
    const childProps = {
      isAuthenticated: true,
      userHasAuthenticated: this.userHasAuthenticated,
      views: this.state.views,
    };
    if (this.props.authState !== 'signedIn') {
      return null;
    }

    return (
      <>
        {this.state.staleVersion && this.displayToast()}
        <Navbar fluid collapseOnSelect>
          <Navbar.Header>
            <Navbar.Brand>
              <Link
                onClick={() => {
                  this.updateHighlight(4);
                }}
                to="/home"
                style={{ fontWeight: 'bold' }}
              >
                Home
              </Link>
            </Navbar.Brand>

            <Nav>
              <NavDropdown
                key="internalApps"
                eventKey="internalApps"
                title="Internal Apps"
                style={{}}
              >
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    window.open('https://facility.farmerfridge.com/', '_blank');
                  }}
                  eventKey={6.1}
                >
                  Facility CMS
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    window.open('https://driver.farmerfridge.com/', '_blank');
                  }}
                  eventKey={6.2}
                >
                  Driver&apos;s App
                </MenuItem>
              </NavDropdown>
            </Nav>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse style={{ padding: '0' }}>
            <Nav activeKey={this.state.currentKey} pullRight>
              {/*
              <NavDropdown key={'customer-facing'} eventKey={'customer-facing'} title="Customer Facing" id="basic-nav-dropdown">
                <MenuItem onClick={e => {e.preventDefault(); this.updateHighlight('customer-facing');this.props.history.push("/customer-facing/coupon");}} eventKey={6.1}>Coupons
                </MenuItem>
              </NavDropdown>
            */}
              <NavDropdown
                key="reports"
                eventKey="reports"
                title="Reporting"
                id="basic-nav-dropdown-1"
              >
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href =
                      'https://facility.farmerfridge.com/reports/allocation';
                  }}
                  eventKey={5.1}
                >
                  Today&apos;s Packing Slip
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href =
                      'https://facility.farmerfridge.com/reports/allocation';
                  }}
                  eventKey={5.2}
                >
                  Historical Allocation
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('reports');
                    this.props.history.push('/reports/checkpoints');
                  }}
                  eventKey={5.3}
                >
                  Checkpoints
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('reports');
                    this.props.history.push('/reports/stockouts');
                  }}
                  eventKey={5.4}
                >
                  Stock Outs
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('reports');
                    this.props.history.push('/reports/emptychannels');
                  }}
                  eventKey={5.5}
                >
                  Empty Channel
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('reports');
                    this.props.history.push('/reports/stockinglogs');
                  }}
                  eventKey={5.6}
                >
                  Stocking Logs
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('reports');
                    this.props.history.push('/reports/routetemperatures');
                  }}
                  eventKey={5.6}
                >
                  Route Temperatures
                </MenuItem>
                {this.state.hasAccessToDropOverride && (
                  <MenuItem
                    onClick={(e) => {
                      e.preventDefault();
                      this.updateHighlight('reports');
                      this.props.history.push('/reports/dropoffsummary');
                    }}
                    eventKey={5.7}
                  >
                    Drop Off Summary
                  </MenuItem>
                )}
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href =
                      'https://facility.farmerfridge.com/receivinginvoices';
                  }}
                  eventKey={5.8}
                >
                  Receiving Invoices
                </MenuItem>
              </NavDropdown>
              <NavDropdown
                key="routes"
                eventKey="routes"
                title="Routes"
                id="basic-nav-dropdown"
              >
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('routes');
                    this.props.history.push('/locations/view_routes');
                  }}
                  eventKey={6.1}
                >
                  View
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('routes');
                    this.props.history.push('/locations/update_weekly_routes');
                  }}
                  eventKey={6.2}
                >
                  Upload
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('routes');
                    this.props.history.push('/nextmv');
                  }}
                  eventKey={6.3}
                >
                  Nextmv
                </MenuItem>
                {this.state.hasAccessToJitManagement && (
                  <MenuItem
                    onClick={(e) => {
                      e.preventDefault();
                      this.updateHighlight('routes');
                      this.props.history.push('/jit-management');
                    }}
                    eventKey={6.4}
                  >
                    JIT Management
                  </MenuItem>
                )}
              </NavDropdown>
              <NavDropdown
                key="forecast"
                eventKey="forecast"
                title="Forecast"
                id="basic-nav-dropdown"
              >
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('forecast');
                    this.props.history.push('/forecast/view');
                  }}
                  eventKey={4.1}
                >
                  View
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('forecast');
                    this.props.history.push('/forecast/upload');
                  }}
                  eventKey={4.2}
                >
                  Upload
                </MenuItem>
              </NavDropdown>
              <NavDropdown
                key="pars"
                eventKey="pars"
                title="Pars"
                id="basic-nav-dropdown"
              >
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('pars');
                    this.props.history.push('/pars/list');
                  }}
                  eventKey={3.1}
                >
                  View
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('pars');
                    this.props.history.push('/pars/upload');
                  }}
                  eventKey={3.2}
                >
                  Upload
                </MenuItem>
              </NavDropdown>
              <NavDropdown
                key="locations"
                eventKey="locations"
                title="Locations"
                id="basic-nav-dropdown"
              >
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('locations');
                    this.props.history.push('/locations/all');
                  }}
                  eventKey={2.1}
                >
                  All
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('locations');
                    this.props.history.push('/locations/new');
                  }}
                  eventKey={2.2}
                >
                  Add Fridge
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('locations');
                    this.props.history.push('/locations/fridge_software');
                  }}
                  eventKey={2.2}
                >
                  View Fridge Software
                </MenuItem>
              </NavDropdown>
              <NavDropdown
                key="channelManagement"
                eventKey="channelManagement"
                title="Channel Management"
                id="basic-nav-dropdown"
              >
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('planograms');
                    this.props.history.push('/planograms');
                  }}
                  eventKey={7.1}
                >
                  Planogram
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('downloadItemPrices');
                    this.props.history.push('/base-price-landing');
                  }}
                  eventKey={7.2}
                >
                  View/Download Base Prices
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('csvPricing');
                    this.props.history.push('/base-price-management');
                  }}
                  eventKey={7.3}
                >
                  Update Base Prices
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('schemaConditions');
                    this.props.history.push('/schema-conditions');
                  }}
                  eventKey={7.4}
                >
                  View/Download Fridge Schema Conditions
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('schemaTemplatesUpload');
                    this.props.history.push('/fridge-schemas/upload');
                  }}
                  eventKey={7.5}
                >
                  Update/Create Fridge Schemas
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.updateHighlight('bulkScheduler');
                    this.props.history.push('/locations/bulk_schedule');
                  }}
                  eventKey={7.6}
                >
                  Bulk Scheduler
                </MenuItem>
              </NavDropdown>
              <NavDropdown
                key="user"
                eventKey="user"
                title="User"
                id="basic-nav-dropdown"
              >
                <MenuItem
                  onClick={(e) => {
                    e.preventDefault();
                    this.handleLogout();
                  }}
                  eventKey={1.1}
                >
                  Log Out
                </MenuItem>
                <MenuItem divider />
                <MenuItem disabled eventKey={1.3}>
                  User:
                  {this.state.user}
                </MenuItem>
                <MenuItem disabled eventKey={1.2}>
                  Location Services:
                  {this.state.position.status.startsWith('UNKNOWN') && (
                    <Glyphicon glyph="question-sign" />
                  )}
                  {this.state.position.status.startsWith('OK') && (
                    <Glyphicon glyph="ok-sign" />
                  )}
                  {this.state.position.status.startsWith('ERROR') && (
                    <Glyphicon glyph="remove-sign" />
                  )}
                </MenuItem>
                <MenuItem disabled eventKey={1.0}>
                  Version:
                  {packageSetting.version}
                </MenuItem>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <PageViewContainer>
          <Routes childProps={childProps} />
        </PageViewContainer>
        <ToastContainer />
      </>
    );
  }
}

export default withRouter(App);
